import axios from "axios";
import { axiosInstance } from "./intreceptor";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

class taxonomyService {
  
  getTaxonomy  = (comp_id) => {
    return axiosInstance
    .get(`/taxonomy/gettaxonomy`, {
		params :{ comp_id : comp_id}
	})
    .then(response => {
      return response
    })
    .catch((err) => {
      console.log(err);
    });
  }

  getDomain = (comp_id) => {
    return axiosInstance
    .get(`/taxonomy/gettaxonomy`, {
		params :{ comp_id : comp_id}
	})
    .then(response => {
      return response.data
    })
    .catch((err) => {
      console.log(err);
    });
  }

  createDomain = (payload) => {
    return axiosInstance
      .post("/taxonomy/createdomain",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  updateDomain = (payload) => {
    return axiosInstance
      .post("/taxonomy/updatedomain",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  deleteDomain = (payload) => {
    return axiosInstance
      .post("/taxonomy/deletedomain",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  createCategory = (payload) => {
    return axiosInstance
      .post("/taxonomy/createcategories",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  updateCategory = (payload) => {
    return axiosInstance
      .post("/taxonomy/updatecategories",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  deleteCategory = (payload) => {
    return axiosInstance
      .post("/taxonomy/deletecategories",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  createAttributes = (payload) => {
    return axiosInstance
      .post("/taxonomy/createattributes",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

  getAttribute = (payload) => {
    return axiosInstance
    .get(`/taxonomy/get_attributes_list`,{params: payload})
    .then(response => {
      return response.data
    })
    .catch((err) => {
      console.log(err);
    });
  }
  

}

export default new taxonomyService();
